import Axios from 'axios';
import Cookies from 'js-cookie';
import storage from 'local-storage-fallback';
import qs from 'qs';

export default {
  login(username, password) {
    return new Promise((resolve, reject) => {
      Axios.post(
        `${window.gdEnv.VUE_APP_API_URL}/groovedigital/auth/login`,
        qs.stringify({ email: username, password })
      )
        .then(res => {
          this.setUserData(res.data,true);
          resolve(res.data);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  ssoLogin(token) {
    return new Promise((resolve, reject) => {
      Axios.post(
        `${window.gdEnv.VUE_APP_API_URL}/groovedigital/auth/sso-login/${token}`,
        qs.stringify({ token })
      )
        .then(res => {
          if (res.data.hasOwnProperty('email') && res.data.email) {
            this.setUserData(res.data);
            resolve(res.data);
          } else {
            reject(res.data.status);
          }
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  setUserCookie(user){
    const overrideUser = {
      auth_keycloak : user.auth_keycloak,
      email : user.email,
      id : user.id,
      name : user.name,
      token : user.token,
      username : user.username
    };

    Cookies.set('db71ab6b0872a8afd28afe1adf7de4b5', JSON.stringify(overrideUser), { sameSite: 'None', secure: true });
  },
  setUserData(user,cookie = false) {
    const currentDate = new Date();
    const timeToChangeToken = new Date();

    timeToChangeToken.setSeconds(
      currentDate.getSeconds() + user.refresh_expires_in
    );
    user.expired_at = timeToChangeToken;

    storage.setItem('user', JSON.stringify(user));
    storage.setItem('show_promotion', true);

    if( cookie ) this.setUserCookie(user);

    Axios.defaults.headers.common = {
      Authorization: `Bearer ${user.token}`
    };
    
    if (!user.auth_keycloak) {
      Axios.defaults.headers.common = {
        ...Axios.defaults.headers.common,
        'x-auth-provider': 'auth0'
      };
    }
  },
  register(username, password) {
    return new Promise((resolve, reject) => {
      Axios.post(
        `${window.gdEnv.VUE_APP_API_URL}/groovedigital/auth/register`,
        qs.stringify({ email: username, password })
      )
        .then(res => {
          storage.setItem('user', JSON.stringify(res.data));
          this.setUserCookie(user);
          Axios.defaults.headers.common = {
            Authorization: `Bearer ${res.data.token}`
          };
          resolve(res.data);
        })
        .catch(err => {
          reject(err.response.data.message);
        });
    });
  },
  authenticatedUser(target = null) {
    let cookieUser = null;
    let storageUser = null;

    if( Cookies.get('db71ab6b0872a8afd28afe1adf7de4b5')) {
      if( Cookies.get('db71ab6b0872a8afd28afe1adf7de4b5') === '4236a440a662cc8253d7536e5aa17942' ){
        storage.removeItem('user');
        storage.removeItem('show_promotion');
        Axios.defaults.headers.common = { Authorization: null };

        return false;
      } 
        cookieUser = JSON.parse(Cookies.get('db71ab6b0872a8afd28afe1adf7de4b5') || '{}');
      
    }
    
    if (storage.getItem('user')) {
      const tempstorageUser = JSON.parse(storage.getItem('user'));

      Axios.defaults.headers.common = {
        Authorization: `Bearer ${tempstorageUser.token}`
      };
      
      storageUser = tempstorageUser;
    }

    if( cookieUser || storageUser ){
      const finalUser = {...(storageUser || {}),...(cookieUser || {})};
      if( target === 'promo_tools' )
        this.setUserData(finalUser);


      return finalUser;
    }

    return false;
  },
  getMinutesForRefresh(expiredIn) {
    if (expiredIn) {
    }
    return expiredIn / 60 - 1;
  },
  logout() {
    storage.removeItem('user');
    storage.removeItem('show_promotion');
    Cookies.set('db71ab6b0872a8afd28afe1adf7de4b5', '4236a440a662cc8253d7536e5aa17942', { sameSite: 'None', secure: true });
    Axios.defaults.headers.common = { Authorization: null };
  },
  refreshToken(token) {
    Axios.post(
      `${window.gdEnv.VUE_APP_API_URL}/groovedigital/auth/refresh_token`,
      qs.stringify({ token })
    )
      .then(res => {
        const user = JSON.parse(storage.getItem('user'));

        user.token = res.data.token;
        user.refresh_token = res.data.refresh_token;
        user.refresh_expires_in = res.data.refresh_expires_in;
        user.expires_in = res.data.expires_in;

        storage.setItem('user', JSON.stringify(user));
        this.setUserCookie(user);
        Axios.defaults.headers.common = {
          Authorization: `Bearer ${user.token}`
        };
        resolve(res.data);
      })
      .catch(err => {
        reject(err.response);
      });
  },
  updateMeta(values) {
    const user = JSON.parse(storage.getItem('user'));
    if (!user.metadata) user.metadata = {};
    user.metadata = { ...user.metadata, ...values };
    storage.setItem('user', JSON.stringify(user));
    this.setUserCookie(user);
  },
  updateDetails(name, email) {
    const user = JSON.parse(storage.getItem('user'));
    user.name = name;
    user.email = email;
    storage.setItem('user', JSON.stringify(user));
    this.setUserCookie(user);
  },
  updateMetadata(metadata) {
    const user = JSON.parse(storage.getItem('user'));
    user.metadata = metadata;
    localStorage.setItem('user', JSON.stringify(user));
    this.setUserCookie(user);
  },
  fetchFeatureValue(feature) {
    if (storage.getItem('user')) {
      const user = JSON.parse(storage.getItem('user'));

      if (user.hasOwnProperty('features')) {
        const { features } = user;
        return parseInt(features[feature]);
      }

      return false;
    }
    return false;
  },
  fetchPlanName() {
    if (storage.getItem('user')) {
      const user = JSON.parse(storage.getItem('user'));

      if (user.hasOwnProperty('plan')) {
        const { plan } = user;
        return plan.name;
      }

      return false;
    }
    return false;
  },
  fetchUserSubscriptionData() {
    return new Promise((resolve, reject) => {
        Axios.get(
          `${window.gdEnv.VUE_APP_API_URL}/groovedigital/auth/fetch-user-subscriptions`,
        )
          .then(res => {
            this.setUserData(res.data);
  
            resolve(res.data);
          })
          .catch(err => {
            reject(err.response);
          });
      });    
  }
};
